import React from 'react';
import { compose } from 'ramda';

import { RichText, Image } from '@synergycms_core/components/generic/';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import styleFile from './LoadingBook.js';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

const LoadingBook = class LoadingBook extends React.Component {
    static displayName = 'LoadingBook';
    render() {
        const { config, theme} = this.props;
        const { classes } = theme.styles;

        return (
            <div className={classes.loadingWrapper}>
                <div className={classes.loadingContainer}>
                    <Image innerStyle={classes.loadingSvg} svg={'loadingSvg'} config={config.image}/>
                    <RichText innerStyle={classes.descriptionText} config={config.richText} >
                        {config.text}
                    </RichText>
                </div>
            </div>
        );
    }
};

export default compose(
    PropertyManager(['text', 'richText', 'image']),
    withContent('contentTheme'),
    withThemeJSS({ styleFile, link: true })
)(LoadingBook);
